module.exports = __webpack_public_path__ + "img/pants side seam length.2ad19371.png";